var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0227 18.1248C7.82597 15.8467 7.82597 12.1533 10.0227 9.87522M6.84054 21.4247C2.88649 17.3242 2.88649 10.6759 6.84054 6.57539M17.9776 18.1248C20.1742 15.8467 20.1742 12.1533 17.9776 9.87522M21.1596 21.4247C25.1138 17.3242 25.1138 10.6759 21.1596 6.57539M15.1251 14.0001C15.1251 14.6444 14.6215 15.1668 14.0001 15.1668C13.3788 15.1668 12.8751 14.6444 12.8751 14.0001C12.8751 13.3558 13.3788 12.8335 14.0001 12.8335C14.6215 12.8335 15.1251 13.3558 15.1251 14.0001Z",
    stroke: "#005F73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensor);
export default __webpack_public_path__ + "static/media/sensor.251f545541d7bb6d98f23710b22634df.svg";
export { ForwardRef as ReactComponent };